// @flow
import { compose, mapProps } from 'recompose'
import CustomModalContent from '../../ui/views/custom-modal-content'

const withPresentationProps = mapProps(props => ({
  title: 'How to bid',
  content:
    'Bidding requires a valid credit card. Chairbids may authorize your card (but not charge yet) when a bid is placed to ensure funds for the charity. When an auction finishes, all winning bids are automatically charged.',
  isRichText: true
}))

export const HowToBidEnhancer = compose(withPresentationProps)

export default HowToBidEnhancer(CustomModalContent)



// WEBPACK FOOTER //
// ./src/services/item/HowToBid.js